
namespace TabAurous.JobWork {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class JobWorkReturnDialog extends _Ext.TransDialog<JobWorkReturnRow, any> {

        protected getFormKey() { return JobWorkReturnForm.formKey; }
        protected getIdProperty() { return JobWorkReturnRow.idProperty; }
        protected getLocalTextPrefix() { return JobWorkReturnRow.localTextPrefix; }
        protected getNameProperty() { return JobWorkReturnRow.nameProperty; }
        protected getService() { return JobWorkReturnService.baseUrl; }
        protected getDeletePermission() { return JobWorkReturnRow.deletePermission; }
        protected getInsertPermission() { return JobWorkReturnRow.insertPermission; }
        protected getUpdatePermission() { return JobWorkReturnRow.updatePermission; }

        public form = new JobWorkReturnForm(this.idPrefix);
        TaxArray: any[];
        PartyTaxState: number;
        TaxRegistred: number;



        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width 
            q.hideEditorLabel(this.form.ItemDetails);
            //q.hideEditorLabel(this.form.MaterialDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.setGridEditorHeight(this.form.TaxDetails, 150);
            q.hideEditorTab
            q.hideCaption(this.form.LedgerName);
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            //q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.TaxDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);

            this.form.TaxDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });

            q.setTextRightAlign(this.form.RoundOff);
            this.form.RoundOff.changeSelect2(e => {
                this.form.GrossAmount.value = this.form.GrossAmount.value + this.form.RoundOff.value;
            });
            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {

                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value); 
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                switch (PartyDetails.TaxRegType) {
                    case "288":// Exempted
                        this.PartyTaxState = 0;
                        break;
                    case "289":
                        this.PartyTaxState = 1;
                        break;
                    case "290": //URD
                        this.PartyTaxState = 2;
                        break;
                }
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });

            //this.form.DepartmentId.changeSelect2(e => {
            //    this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            //});

            //this.form.OrderType.changeSelect2(e => {
            //    var value = this.form.OrderType.value
            //    if (value == "1")
            //        JobWorkReturnItemsEditor.type = 1;
            //    else if (value == "2")
            //        JobWorkReturnItemsEditor.type = 2;
            //});

            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
          
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                //check++;
                var  Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getItems().length; 
                if (Items.length == TotalItems) {

                    this.CalculateAmountandTax(Items,   TotalItems);
                } 
            });

            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );


        }
        protected inplaceSearchClick(e: any): void {
            var grid = OMS.VendorGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Supplier"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.VendorRow[]) => {

                this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                this.form.LedgerName.value = selectedItems[0].LedgerName;

                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.LedgerName.value = selectedItems[0].LedgerName;
                this.form.ItemDetails.RateListId = selectedItems[0].CostPricegroupId == null ? 0 : selectedItems[0].CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                this.form.ItemDetails.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                this.form.ItemDetails.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;
                this.TaxRegistred = parseInt(selectedItems[0].TaxRegType);

                this.form.GstVat.value = selectedItems[0].GstVat;

                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            }
            pickerDialog.dialogOpen();

        }
        public CalculateAmountandTax(Items: any, TotalItems: number) {
            var ItemTotal = 0;
            var HSN = [];
            var Amount = [];
            var TaxDetail = [];

            var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var wt = 0; var nwt = 0; var tds = 0;

            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;
                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;

                var temp = false;
                for (let i = 0; i < HSN.length; i++) {
                    if (HSN[i] == x.TaxCode) {
                        Amount[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    HSN.push(x.TaxCode);
                    Amount.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {

                var TaxItems = this.form.TaxDetails.getItems().length;
                var it = this.form.TaxDetails.getItems();
                if (TaxItems > 0) {
                    this.form.TaxDetails.DeleteTax();
                }

                let partystate = this.form.State.value;
                var Cmpstate = OMS.CompanyRow.getLookup().itemById[Q.Authorization.userDefinition.CompanyId].State;

                //TODO: Get Company Country to Call appropriate TAX Helper

                if (this.TaxRegistred != 290 && this.TaxRegistred != 288) {
                    if (partystate == Cmpstate) {
                        //TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, false, this.TaxRegistred);
                        TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, false);
                    }
                    else {
                        //TaxDetail = TaxHelper.NewTaxCalculation(HSN, Amount, this.form.TransDate.value, true, this.TaxRegistred);
                        TaxDetail = TaxHelper.VoucherTaxCalculation(this.form.VoucherTypeId.value, gramt, this.form.TransDate.value, TaxDetail, true);
                    }

                    var temp2 = this.form.TaxDetails.getData(TaxDetail);
                    this.form.TaxDetails.view.setItems(temp2, true);

                    TaxDetail.forEach(function (value) {
                        if (value.TaxType != "TDS")
                            TaxAmount += value.TaxAmount;
                        else
                            tds += value.TaxAmount;
                    });
                }

                this.form.TaxAmount.value = TaxAmount;
                this.form.GrossAmount.value = gramt + TaxAmount;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;
                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
        }

        protected onDialogOpen() {
            super.onDialogOpen();

            if (this.form.CompanyId.value != 0 || this.form.FinancialYearId.value != 0) {
                this.form.CompanyId.value = Q.Authorization.userDefinition.CompanyId;
                this.form.FinancialYearId.value = Q.Authorization.userDefinition.FinancialYearId;
                this.form.CurrencyId.value = Q.Authorization.userDefinition.CurrencyId.toString();
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }
            if (this.form.PartyId.value != "") {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.LedgerName.value = PartyDetails.LedgerName;

                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;

                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )

            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                JobWorkReturnService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }



        public getForm() { return this.form; }
        public setForm(form) {
            this.form = form
        }
        protected validateBeforeSave() {
            var items = this.form.ItemDetails.getItems();
            for (var i = 0; i < items.length; i++) {
                if (items[i].HasBom == true) {
                    if (items[i].BOMDetails.length == 0) {
                        Q.alert('Cannot save item ' + items[i].ProductCode + ' without BOM');
                        return false;
                    }
                }
                items[i].MetalAmount = items[i].MetalAmount == null || '' ? 0 : items[i].MetalAmount;
                items[i].OtherAmount = items[i].OtherAmount == undefined || '' ? 0 : items[i].OtherAmount;
                items[i].DiamondAmount = items[i].DiamondAmount == null || '' ? 0 : items[i].DiamondAmount;
                items[i].StoneAmount = items[i].StoneAmount == null || '' ? 0 : items[i].StoneAmount;
                items[i].UnitCost = items[i].UnitCost == undefined || '' ? 0 : items[i].UnitCost;

                items[i].Discount = items[i].Discount == undefined || '' ? 0 : items[i].Discount;
                items[i].Remark = items[i].Remark == undefined || '' ? 'NA' : items[i].Remark;
                items[i].SpecialRemark = items[i].SpecialRemark == undefined || '' ? 'NA' : items[i].SpecialRemark;
                items[i].WstPer = items[i].WstPer == undefined || '' ? 0 : items[i].WstPer;
                items[i].WstWt = items[i].WstWt == undefined || '' ? 0 : items[i].WstWt;

            }
            return true;
        }
    }
}